import React from 'react';

//  components
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import { default as PendingTransactionsContent } from '../../modules/Accounts/PendingTransactions';

const PendingTransactions = () => {
  return (
    <PageContentCard>
      <PendingTransactionsContent />
    </PageContentCard>
  );
};

export default PendingTransactions;
